import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface SignUpState {
  email: string | null;
  name: string | null;
  companyName: string | null;
  userId: string | null;
  termsAccepted: boolean;
  discountCode: string | null;
  referralCode: string | null;
  setEmail: (email: string) => void;
  setName: (name: string) => void;
  setCompanyName: (companyName: string) => void;
  setUserId: (userId: string) => void;
  setTermsAccepted: (termsAccepted: boolean) => void;
  setDiscountCode: (discountCode: string) => void;
  setReferralCode: (referralCode: string) => void;
  reset: () => void;
}

export const useSignUpStore = create<SignUpState>()(
  persist(
    (set) => ({
      email: null,
      name: null,
      companyName: null,
      userId: null,
      termsAccepted: false,
      discountCode: null,
      referralCode: null,
      setEmail: (email) => set({ email }),
      setName: (name) => set({ name }),
      setCompanyName: (companyName) => set({ companyName }),
      setUserId: (userId) => set({ userId }),
      setTermsAccepted: (termsAccepted) => set({ termsAccepted }),
      setDiscountCode: (discountCode) => set({ discountCode }),
      setReferralCode: (referralCode) => set({ referralCode }),
      reset: () => set({
        email: null,
        name: null,
        companyName: null,
        userId: null,
        termsAccepted: false,
        discountCode: null,
        referralCode: null,
      }),
    }),
    {
      name: 'onboarding-storage',
    }
  )
);
